import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66637c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-body" }
const _hoisted_2 = { class: "form-group-title" }

import {FormContainerGroup} from "@/components/business/crud/widgets/FormWidgetContainer";
import WidgetFormGroup from "@/components/business/crud/form/WidgetFormGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetFormBody',
  props: {
    groups: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "form-group",
        key: group.title
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(group.title), 1),
        _createVNode(WidgetFormGroup, { group: group }, null, 8, ["group"])
      ]))
    }), 128))
  ]))
}
}

})